import DEFAULT_AVATAR from 'images/agentDefaultAvatar.svg'
import { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

const DEFAULT_RECIPIENT = {
  id: null,
  name: '',
  avatarUrl: DEFAULT_AVATAR,
  bot: false
}

interface ResolvedRecipient {
  recipient: Recipient
}

interface Recipient {
  id: number,
  name: string,
  avatarUrl: string,
  bot?: boolean,
  publicProfileUrl?: string | null,
  title?: string | null,
  status?: string | null
}

const useRecipientResolution = (agentId: number | null | undefined) : ResolvedRecipient  => {
  const { t } = useTranslation()

  const { team = [] } = useSelector(state => (
    state.embed.configuration
  ))

  const getRecipientName = useCallback((recipient) => {
    if (!recipient) {
      return ''
    }

    if (!recipient.name || recipient.name === '') {
     return recipient.bot ? "Bot" : t('agent')
    }

    return recipient.name
  }, [t])

  const getRecipientAvatarUrl = useCallback((recipient) => {
    if (!recipient) { return DEFAULT_AVATAR }

    if (recipient.avatarUrl) {
      return recipient.avatarUrl
    }

    if (!recipient.bot) {
      return DEFAULT_AVATAR
    }

    return null
  }, [])

  const recipient = useMemo<ResolvedRecipient>(() => {
    if (!agentId) {
      return {
        recipient: DEFAULT_RECIPIENT
      }
    }

    const recipient = team.find(user => user.id === agentId)

    return {
      recipient: {
        ...recipient,
        avatarUrl: getRecipientAvatarUrl(recipient),
        name: getRecipientName(recipient)
      }
    }
  }, [agentId, team, getRecipientName, getRecipientAvatarUrl])

  return recipient
}

export default useRecipientResolution
